// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__38Wea","col":"styles_col__1Z2nJ"};